module.exports = __webpack_public_path__ + "img/blackcat-cideb.557bb346.png";